import { useSelector, useDispatch } from "react-redux";
import { fetchInvitationByCode, clearInvitation } from "../../redux/invitation/invitationSlice";
import { useCallback } from "react";
import { RootState } from '../../redux';
import { AppDispatch } from '../../redux';

const useFetchInvitationByCode = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { invitation, status, error, isLoading} = useSelector((state: RootState) => state.invitation);

  const fetchInvitation = useCallback(async (code: string) => {
    try {
      await dispatch(fetchInvitationByCode(code)).unwrap();
    } catch (error) {
      console.error('Failed to fetch invitation:', error);
    }
  }, [dispatch]);


  return { 
    invitation, 
    status, 
    error, 
    isLoading, 
    fetchInvitation,
  };
};

export default useFetchInvitationByCode; 